export const LogoMark = ({ className = "h-8 w-auto", variant = "dark" }) => (
    <img
        src={variant === "white" ? "/elcayil-logo-white.png" : "/elcayil-logo.png"}
        alt="ELCAYIL logo"
        className={`${className} object-contain`}
        draggable="false"
    />
);

export default LogoMark;
